import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadGoogleMapsScript } from './utils/loadGoogleMaps';

// Suppress Google Maps authorization errors that don't affect functionality
// RefererNotAllowedMapError is expected in development if API key restrictions are set
if (typeof window !== 'undefined') {
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args[0]?.toString() || '';
    // Suppress Google Maps referer/authorization errors - they don't break functionality
    if (message.includes('Google Maps') && (
      message.includes('RefererNotAllowed') ||
      message.includes('Referer not allowed') ||
      message.includes('authorization') ||
      message.includes('API key')
    )) {
      // Log for debugging but don't propagate
      return;
    }
    // Pass through all other errors
    originalConsoleError.apply(console, args);
  };
}

// Load Google Maps script dynamically with API key from environment
// This keeps the API key secure in .env.local and out of HTML source
console.log('Initializing Google Maps...');
loadGoogleMapsScript({ libraries: 'places' })
  .then(() => {
    console.log('✅ Google Maps API loaded successfully');
    console.log('📍 Autocomplete features ready for address fields');
  })
  .catch((err) => {
    console.error('❌ Failed to load Google Maps:', err.message);
    console.error('📋 Troubleshooting:');
    console.error('   1. Verify REACT_APP_GOOGLE_MAPS_API_KEY in .env.local');
    console.error('   2. Restart development server after adding/changing key');
    console.error('   3. Check Google Cloud Console for API key validity');
    console.error('   4. For localhost: Add http://localhost:3000/* to API key restrictions');
    // App can still render, but map/autocomplete features will not work
  });

// Create a root element for the React application.
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component in StrictMode.
// StrictMode is a tool for highlighting potential problems in an application.
// It activates additional checks and warnings for its descendants.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
